import React from "react";
import {Model, surveyLocalization} from "survey-core";
import {Survey} from "survey-react-ui";
import "survey-core/survey-core.css";
import {db} from "../../firebase";
import {addDoc, collection} from "firebase/firestore";

surveyLocalization.locales["el"] = {
    pagePrevText: "Πίσω",
    pageNextText: "Επόμενο",
    completeText: "Ολοκλήρωση",
    requiredError: "Απαιτείται απάντηση.",
    emailError: "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση e-mail."
};
surveyLocalization.defaultLocale = "el";

const DiseaseFormPage = () => {
    const surveyJson = {
        completedHtml: "<h3>Σας ευχαριστούμε που υποβάλατε την αίτηση.</h3>",
        title: "Υποβολή Αιτήματος για προσθήκη Σπάνιας Πάθησης στον Ελληνικό Χάρτη Σπανίων Παθήσεων (Rare Diseases Greece Map)",
        description: `Ο Ελληνικός Χάρτης Σπανίων Παθήσεων είναι ένα δυναμικό εργαλείο στο οποίο προστίθενται συνεχώς όσες πληροφορίες είναι διαθέσιμες για τις Σπάνιες Παθήσεις που έχει καταγράψει η Ένωση Σπανίων Ασθενών Ελλάδος, με τις οποίες έχουν διαγνωστεί ασθενείς στην Ελλάδα.
Σε περίπτωση που επιθυμείτε την προσθήκη μίας νέας Σπάνιας Πάθησης, η οποία δεν υπάρχει στον Χάρτη, μπορείτε να πραγματοποιήσετε αίτημα προσθήκης, συμπληρώνοντας την παρούσα φόρμα, με όποια στοιχεία γνωρίζετε για αυτήν:
Είναι σημαντικό να συμπληρωθούν όσο το δυνατόν περισσότερα στοιχεία`,
        pages: [{
            name: "disease", elements: [{
                type: "text", name: "Ελληνικό Όνομα Πάθησης", title: "Ελληνικό Όνομα Πάθησης:"
            }, {
                type: "text", name: "Αγγλικό Όνομα Πάθησης", title: "Αγγλικό Όνομα Πάθησης:", isRequired: true
            }, {
                type: "text", name: "Συντομογραφία Πάθησης", title: "Συντομογραφία Πάθησης:"
            }, {
                type: "text", name: "ORPHACODE", title: "ORPHACODE:"
            }, {
                type: "text",
                name: "Κέντρο Εμπειρογνωμοσύνης",
                title: "Κέντρο Εμπειρογνωμοσύνης / Ειδική Μονάδα / Ειδικό Ιατρείο:"
            }]
        }, {
            name: "applicant", elements: [{
                type: "text",
                name: "Ονοματεπώνυμο Αίτησης",
                title: "Ονοματεπώνυμο Ατόμου που πραγματοποιεί την αίτηση:",
                isRequired: true
            }, {
                type: "text",
                name: "Email Αίτησης",
                title: "Email Ατόμου που πραγματοποιεί την αίτηση:",
                inputType: "email",
                isRequired: true
            }, {
                type: "html", name: "declaration", html: `<p>
Η Ένωση Σπανίων Ασθενών Ελλάδος (Ε.Σ.Α.Ε) συλλέγει και επεξεργάζεται τα προσωπικά σας δεδομένα αποκλειστικά για σκοπούς επικοινωνίας. 
Η επεξεργασία των δεδομένων σας διέπεται από τον Γενικό Κανονισμό για την Προστασία Δεδομένων (ΕΕ) 2016/679 και τον Νόμο 4624/2019. 
Με την υποβολή αυτής της φόρμας, δηλώνετε ότι έχετε διαβάσει και κατανοήσει την ενημέρωση σχετικά με την επεξεργασία των προσωπικών σας δεδομένων.
            </p>`
            }]
        }]
    };

    const survey = new Model(surveyJson);

    // Save survey response to Firestore upon completion
    survey.onComplete.add(async (sender) => {
        const surveyData = sender.data;
        try {
            await addDoc(collection(db, "addDiseaseForm"), surveyData);
            console.log("Survey response saved to Firestore:", surveyData);
        } catch (error) {
            console.error("Error saving survey response to Firestore:", error);
        }
    });

    return (<div className="survey-container">
        <Survey model={survey}/>
        <footer
            style={{
                textAlign: "center", fontSize: "x-large", color: "#555"
            }}
        >
            Καπνικαρέας 19Α | Αθήνα | 10556 | T. 694 344 8509 | E. info@rarediseasesgreece.gr
        </footer>
    </div>);
};

export default DiseaseFormPage;
